import React, { PureComponent } from 'react';

import FileTransferProgressStateEnum from '../../../../../common/constants/FileTransferProgressStateEnum';

import { Delete as DeleteIcon, GetApp as DownloadIcon } from '@mui/icons-material';
import { IconButton, Tooltip, Zoom } from '@mui/material';

import Tile from '../../../../../common/components/Tile/Tile';
import TableEnhancedContainer from '../../../../../common/components/TableEnhanced/TableEnhancedContainer';
import ConfirmationDialog from '../../../../../common/components/ConfirmationDialog/ConfirmationDialog';
import Loading from '../../../../../common/components/Loading/Loading';

class BlobFileList extends PureComponent {
  constructor(props) {
    super();

    this.styleConfig = {
      width: '10rem',
    };

    this.columnsConfig = props.columnsConfig
      ? props.columnsConfig
      : [
          {
            name: 'File',
            key: 'displayAddress',
            type: 'string',
            visible: true,
            filterable: true,
            sortable: true,
          },
          {
            name: 'File size (MB)',
            key: 'sizeInMb',
            type: 'number',
            visible: true,
            filterable: true,
            sortable: true,
          },
          {
            name: 'Date modified',
            key: 'lastModified',
            visible: true,
            filterable: true,
            sortable: true,
          },
          {
            name: 'Status',
            key: 'status',
            type: 'string',
            visible: true,
            filterable: true,
            sortable: true,
          },
          {
            name: 'Actions',
            key: null,
            type: 'markup',
            style: this.styleConfig,
            markup: (el, col, elIndex, colIndex) => {
              return (
                <div>
                  <Tooltip disableInteractive TransitionComponent={Zoom} title="Download">
                    <IconButton
                      size="large"
                      key={1}
                      style={{}}
                      onClick={() => {
                        return props.onClickDownload(el.blobLink);
                      }}
                      data-qa="qa-download"
                      disabled={isDownloadButtonDisabled(el.status)}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                    <IconButton
                      key={2}
                      style={{}}
                      onClick={() => {
                        return props.onClickDelete(el.blobLink, el.displayAddress);
                      }}
                      data-qa="qa-delete"
                      disabled={isDeleteButtonDisabled(el.status)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              );
            },
            visible: true,
            filterable: false,
            sortable: false,
          },
        ];
  }

  render() {
    return (
      <Tile title="Available files" helpTag="file_transfer-available_files">
        <ConfirmationDialog
          onClickCancel={this.props.showConfirmDialog.cancel}
          onClickMainAction={this.props.showConfirmDialog.action}
          open={this.props.showConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirm}
          title={this.props.showConfirmDialog.title}
          mainActionLabel={this.props.showConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showConfirmDialog.disableMainAction}
          key={this.props.messageToConfirm}
        />
        <Loading condition={this.props.isFetching}>
          <TableEnhancedContainer
            {...this.props.data}
            columns={this.columnsConfig}
            className="InstrumentsListTable"
            enableHideColumns={this.props.enableHideColumns ? this.props.enableHideColumns : false}
            enableActionButtons={false}
          />
        </Loading>
      </Tile>
    );
  }
}

export default BlobFileList;

export function isDownloadButtonDisabled(statusDescription) {
  return (
    statusDescription !==
      FileTransferProgressStateEnum.GetDescriptionString(FileTransferProgressStateEnum.FINISHED) &&
    statusDescription !== ''
  );
}

export function isDeleteButtonDisabled(statusDescription) {
  if (
    statusDescription.includes(
      FileTransferProgressStateEnum.GetDescriptionString(FileTransferProgressStateEnum.PREPARED)
    ) ||
    statusDescription.includes(
      FileTransferProgressStateEnum.GetDescriptionString(FileTransferProgressStateEnum.UPLOADING)
    ) ||
    statusDescription.includes(
      FileTransferProgressStateEnum.GetDescriptionString(FileTransferProgressStateEnum.DOWNLOADING)
    )
  ) {
    return true;
  } else {
    return false;
  }
}
